import React from 'react';
import { FaChartLine, FaCogs, FaSearchDollar, FaRocket, FaCheck } from 'react-icons/fa';

const AIConsulting = () => {
  const benefits = [
    {
      icon: <FaChartLine />,
      title: 'Data-Driven Strategy',
      description: 'Transform your business decisions with AI-powered insights and predictive analytics.'
    },
    {
      icon: <FaCogs />,
      title: 'Process Optimization',
      description: 'Streamline operations and enhance efficiency through intelligent automation solutions.'
    },
    {
      icon: <FaSearchDollar />,
      title: 'ROI Assessment',
      description: 'Comprehensive analysis of potential returns and value creation opportunities.'
    }
  ];

  const services = [
    'Strategic AI Roadmap Development',
    'Technology Stack Assessment',
    'Process Automation Planning',
    'Data Strategy & Architecture',
    'AI Implementation Timeline',
    'ROI & Performance Metrics',
    'Risk Assessment & Mitigation',
    'Change Management Strategy'
  ];

  return (
    <div className="min-h-screen bg-nvidia-dark">
      {/* Hero Section */}
      <section className="pt-20 pb-12 bg-gradient-to-b from-nvidia-dark to-nvidia-dark-800">
        <div className="container mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              AI Consulting Services
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Transform your business with expert AI consulting that delivers measurable results. 
              We help organizations navigate the complexities of AI implementation, optimization, 
              and ROI maximization.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-nvidia-dark-800">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12 text-center">Why Choose Our Consulting Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="p-6 rounded-lg bg-nvidia-dark transform hover:-translate-y-1 transition-transform duration-300 border border-nvidia-green/20"
              >
                <div className="text-nvidia-green text-3xl mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gradient-to-b from-nvidia-dark-800 to-nvidia-dark">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">Our Consulting Process</h2>
            <div className="bg-nvidia-dark-800 rounded-lg p-8 border border-nvidia-green/20">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {services.map((service, index) => (
                  <div key={index} className="flex items-center">
                    <FaCheck className="text-nvidia-green mr-3" />
                    <span className="text-gray-300">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-nvidia-dark">
        <div className="container mx-auto px-6">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Business?</h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Let's discuss how our AI consulting services can help you achieve your business objectives.
            </p>
            <button className="bg-nvidia-green text-black px-8 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-colors">
              Schedule a Consultation
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIConsulting;
